import { ICurrentUser } from '@dadohr/shared/domainTypes/currentUser';
import { IRoute } from '@dadohr/shared/domainTypes/routes';
import { hasPermissionToAccessPage } from '../permissions';

export const getFirstAccessibleRoute = (user: ICurrentUser, routes: IRoute[]) =>
  routes.find((route) => hasPermissionToAccessPage(user, route));
